import React from 'react'

export default ({
  workTracker
}) => (
  <div key={workTracker.id} className='work-tracker card'>
    <p className='service-name'><strong>{workTracker.serviceName}</strong></p>
    <p>
      ({workTracker.completed})&nbsp;
      {workTracker.contractedCompleted}/{workTracker.total}
    </p>
    <p>{parseInt(100 * workTracker.contractedCompleted / workTracker.total, 10) || '—'}% Completed</p>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/work-trackers/work-tracker-item.js